import { ApiRequestStatus } from '../../../../model/api-request';

export interface RetrieveUsernameParams {
  userCode?: string;
  squareAgreementCode?: string;
  isRequestFromMultipleMatchPage?: boolean;
}

export enum RetrieveUsernameOptions {
  ByMail = 'retrieveUsernameByMail',
  BySMS = 'retrieveUsernameBySMS',
}

export type RetrieveUsernameError =
  | 'MULTIPLE_MATCH'
  | 'INVALID_EMAIL_FORMAT'
  | 'INVALID_PHONE_NUMBER_FORMAT'
  | 'EMAIL_NOT_FOUND'
  | 'PHONE_NUMBER_NOT_FOUND'
  | 'FIELD_NOT_VALID'
  | 'FIELD_NOT_FILL'
  | 'INVALID_SQUARE_AGREEMENT_CODE'
  | 'GENERIC_ERROR'
  | 'NO_ASSOCIATED_USERS'
  | 'TOO_MANY_REQUESTS';

export enum RetrieveUsernameApiBusinessError {
  MULTIPLE_MATCH = 'CORRISPONDENZA_MULTIPLA',
  NO_ASSOCIATED_USERS = 'NESSUNA_UTENZA_ASSOCIATA',
}
export interface RetrieveUsernameState {
  retrieveUsernameRequestStatus: ApiRequestStatus;
  retrieveUsernameError?: RetrieveUsernameError;
  userType: string;
  selectedOption: RetrieveUsernameOptions;
  userEmail?: string;
  userPhoneNumber?: string;
  
  multipleMatchesFound: boolean;
}
